import axios from "axios";
import { store } from "./redux/store";
import { logout, setCredentials } from "./redux/authSlice";

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});

api.interceptors.request.use((config) => {
    const token = store.getState().auth.token;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const res = await axios.get('/me');
                const { 
                    token, 
                    agent
                } = res.data;

                store.dispatch(
                    setCredentials({ token, agent })
                );

                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                return api(originalRequest);
            } catch (refreshError) {
                store.dispatch(logout());
            }
        }

        return Promise.reject(error);
    }
);

export default api;
